import React, { useState, useCallback, useEffect } from 'react';
import styles from './index.module.less';
import Left from './component/left';
import StepA from './component/stepA';
import StepB from './component/stepB';
import StepC from './component/stepC';
import EmptyHeader from '@/components/EmptyHeader';
import { getQueryStringArgs } from '@/utils/url-parse';
import { history } from 'ice';
import Requests from '@/services/request';

const SettleIn: React.FC = () => {
  const [, setCurrentStep] = useState(0);
  const { companyId, step = '0', invitationCode, spaceId } = getQueryStringArgs();

  const changeSteps = (val) => {
    setCurrentStep(val);
  };

  const getSteps = useCallback(() => {
    if (spaceId && companyId && step === '2') {
      return <StepC changeSteps={changeSteps} />;
    } else if (spaceId && step === '1') {
      return <StepB changeSteps={changeSteps} />;
    } else if (step === '0' || !step) {
      return <StepA />;
    }
  }, [spaceId, step]);

  useEffect(() => {
    Requests.get('/rest/intercnn/invitation/detail', { invitationCode }, { toRegisterIfNotLogin: true }, true).catch((err) => {
      history?.push(`/error?reason=${err.errorCode || ''}`);
    });
  }, []);

  return (
    <div className={styles.container}>
      <EmptyHeader />
      <div className={styles.content}>
        <div className={styles.left}>
          <Left currentStep={step} />
        </div>
        <div className={styles.right}>{getSteps()}</div>
      </div>
    </div>
  );
};

export default SettleIn;
